import { render, staticRenderFns } from "./view-cookies.vue?vue&type=template&id=790e6cf1&scoped=true"
import script from "./view-cookies.vue?vue&type=script&lang=js"
export * from "./view-cookies.vue?vue&type=script&lang=js"
import style0 from "./view-cookies.vue?vue&type=style&index=0&id=790e6cf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e6cf1",
  null
  
)

export default component.exports